import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/user.context";
import { useOnboarding } from "../../contexts/onboarding.context";
import { onboardingSteps, onboardingStepsOrder } from "../../utils/constants";
import AppLoading from "../../components/AppLoading";
import Profile from "./Profile";
import Connect from "./Connect";
import Promise from "./Promise";
import Brand from "./Brand";
import Preview from "./Preview";
import Push from "./Push";
import Conclude from "./Conclude";
import DevStateSwitcher from "./_shared/DevStateSwitcher";

export default function Onboarding() {
    const navigate = useNavigate();
    const { user } = useUser();
    const [isLoading, setIsLoading] = useState(true);

    const { currentStep, goToStep, setData } = useOnboarding();

    useEffect(() => {
        if (user.isOnboardingCompleted) {
            navigate('/');
            return;
        }

        if (user.store) {
            setData(prev => ({
                ...prev,
                ecommercePlatformId: user.store.ecommercePlatformId,
                ecommercePlatformName: user.store.ecommercePlatformName,
                storeId: user.store.id,
                storeAccountUrl: user.store.storeAccountUrl,
                storeCartUrl: user.store.storeCartUrl,
                storeName: user.store.name,
                storeUrl: user.store.storeUrl
            }));
            const isBeforePromise = onboardingStepsOrder.indexOf(currentStep) < onboardingStepsOrder.indexOf(onboardingSteps.PROMISE);
            if (isBeforePromise) {
                goToStep(onboardingSteps.PROMISE);
            }
        }

        setIsLoading(false);
    }, [])

    const getStep = () => {
        switch (currentStep) {
            case onboardingSteps.PROFILE: return <Profile />
            case onboardingSteps.CONNECT: return <Connect />
            case onboardingSteps.PROMISE: return <Promise />
            case onboardingSteps.BRAND: return <Brand />
            case onboardingSteps.PREVIEW: return <Preview />
            case onboardingSteps.PUSH: return <Push />
            case onboardingSteps.CONCLUDE: return <Conclude />
            default: return <Profile />;
        }
    }

    // This is here to prevent flickering when
    // redirecting the user to the dashboard
    if (isLoading)
        return <AppLoading />

    return (
        <>
            {getStep()}
            <DevStateSwitcher />
        </>
    )
}
